<div
  class="attachment-manager-list"
  [ngClass]="{ 'attachment-manager-list--disabled': disabled }"
  drag-drop
  (dragenter)="dragEnter($event)"
  (dragleave)="dragLeave()"
  (filesDropped)="dragDropped(); !disabled ? onFilesChange($event) : null"
  [attachments]="attachments"
  [attachmentsConfig]="attachmentsConfig"
  #textAttachmentControl
>
  <div class="dragging-file" [ngClass]="{ 'dragging-file--visible': entered }">
    <span>{{ 'Attachments.uploadFiles' | translate }}</span>
  </div>

  <div [formGroup]="form" class="d-flex justify-content-between attachment-manager-list__header">
    <div class="d-flex align-items-center attachment-manager-list__header__title">
      <span class="attachment-manager-list__header__title-files"> {{ titleTranslationKey | translate }}</span>
    </div>
    <div class="d-flex align-items-center">
      <app-button
        *ngIf="selectedFilesCount > 0 && !disabled"
        type="button"
        (onClick)="deleteSelectedFiles()"
        class="file-btn file-btn--remove"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.NEW_SECONDARY_NO_BORDER_BLUE,
          text: 'Attachments.remove' | translate,
          prependSrc: './assets/img/trash-icon-red.svg'
        }"
      />

      <app-button
        *ngIf="!selectedFilesCount && !disabled"
        type="button"
        [matMenuTriggerFor]="addAttachmentMenu"
        class="file-btn file-btn--add"
        [config]="{
          size: ButtonSize.LARGE,
          type: ButtonTypes.NEW_SECONDARY_NO_BORDER_BLUE,
          text: 'Attachments.addAttachments' | translate,
          prependSrc: './assets/img/paper-clip-icon.svg'
        }"
      />
      <mat-menu #addAttachmentMenu="matMenu" xPosition="before" class="menu-v2">
        <button mat-menu-item (click)="addFile()">
          <span>{{ 'Attachments.library.fromDevice' | translate }}</span>
        </button>
        <button mat-menu-item (click)="openAttachmentLibrary()">
          <span>{{ 'Attachments.library.fromDocuments' | translate }}</span>
        </button>
      </mat-menu>
      <input type="file" #fileInput (change)="onFilesChange()" multiple [accept]="acceptFiles()" hidden />
    </div>
  </div>

  <div class="d-flex flex-column" [class.mt-3]="fileAttachments?.length">
    <ng-container *ngFor="let attachment of fileAttachments; let i = index; trackBy: trackAttachments">
      <attachment-inline-v2
        [index]="date"
        *ngIf="(!!showLimit && i + 1 <= limit) || !showLimit || !!showAllFiles"
        [disabled]="disabled"
        [form]="form"
        [attachment]="attachment"
        [highlighted]="isHighlighted(attachment)"
        [uploadProgress]="fileUploadProgress().get(attachment.id) ?? 0"
      />
      <ng-container
        *ngIf="afterHighlightedTemplate && i === lastHighlightedIndex"
        [ngTemplateOutlet]="afterHighlightedTemplate"
      />
    </ng-container>
  </div>

  <div class="empty-state text-center mt-2" *ngIf="!isPreview && !fileAttachments?.length">
    <img draggable="false" src="./assets/img/attachment-icon.svg" alt="empty" />
    <span class="text-center w-100 d-block">{{ 'Attachments.noAttachments' | translate }}</span>
  </div>

  <app-button
    class="mt-3"
    [type]="'button'"
    *ngIf="!!showLimit && fileAttachments.length > limit"
    (onClick)="showAllFiles = !showAllFiles"
    [config]="{
      size: ButtonSize.LARGE,
      type: ButtonTypes.DISCARD_BUTTON,
      text: (!showAllFiles ? 'Attachments.showAllFiles' : 'Attachments.hideFiles') | translate
    }"
  />
</div>
